// extracted by mini-css-extract-plugin
export default {"Navigation":"Navigation_Navigation__BN-kU","MarginRight":"Navigation_MarginRight__m5VPg","HoverLogo":"Navigation_HoverLogo__TJXfT"};